import React from "react";
import {
  ComponentDetailsByFileOut,
  InventoryProductDetailsByFileOut,
} from "api-client";
import {
  FIELDSSET_TITLE_CLASSES,
  FIELD_LABEL_CLASSES,
  FIELD_VALUE_CLASSES,
} from "features/MappingEditor/consts";
import { useMappingTools } from "features/MappingEditor/useMappingTools";
import { useTranslation } from "react-i18next";

const GeneralInformation = ({
  details,
}: {
  details:
    | InventoryProductDetailsByFileOut
    | ComponentDetailsByFileOut
    | undefined;
}) => {
  const { t } = useTranslation();
  const { productAdditionalInfo } = useMappingTools();

  return (
    <div className="border-b border-gray-200">
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("mapping.generalInformation")}
      </div>
      <div className="flex flex-wrap justify-start">
        {productAdditionalInfo(
          details as InventoryProductDetailsByFileOut,
          false,
          (details as ComponentDetailsByFileOut)?.type === "COMPONENT"
        ).map((item, index) => {
          return (
            <div key={index} className="mb-2 pr-4 last-of-type:pr-0">
              <div className={FIELD_LABEL_CLASSES}>{item.label}</div>
              <div className={FIELD_VALUE_CLASSES}>{item.value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GeneralInformation;
